import React from 'react';
import { Modal, Input, message, Spin, Radio } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import "../style.less"

const RadioGroup = Radio.Group;

/**
 * 助理审批(CRM合同生成的JDE建号申请 初始状态为 助理审批)
 * 通过: 状态变更为场景状态(和页面新建JDE建号申请一致)
 * 不通过: 状态变更为 助理审批不通过
 */
class AssistantApproval extends React.Component {
    state = {
        loading: false,
        visible: false,
        record: {},
        saveParams: {},
    }

    show = (record) => {
        this.setState({
            visible: true,
            record: { ...record },
            saveParams: {},
        });
    }

    hide = () => {
        this.setState({
            loading: false,
            visible: false,
            record: {},
            saveParams: {},
        });
    }

    handleInputChange = (e, field) => {
        const { saveParams } = this.state;
        const value = e.target.value;
        saveParams[field] = value;
        if (field == 'approvalStatus' && value == 'AGREE') {
            saveParams.comments = '';
        }
        this.setState({ saveParams });
    }

    submit = () => {
        const { record: { jdeApplyId }, saveParams, loading } = this.state;
        const { approvalStatus, comments } = saveParams;
        if (!approvalStatus) {
            message.warning('请选择审批结论');
            return;
        }
        if (approvalStatus == 'DISAGREE' && !comments) {
            message.warning('请输入审批不通过原因');
            return;
        }
        if (loading) {
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.assistantApproval,
            data: {
                jdeApplyId,
                approvalStatus,
                comments,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                    visible: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, saveParams: { approvalStatus, comments } } = this.state;
        return (
            <Modal
                title="助理审批"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="450px"
            >
                <div className="cont-cont" style={{ padding: '0 20px' }}>
                    <Spin spinning={loading}>
                        <ul className="preview-list apply-jde">
                            <li className="preview-item">
                                <div className="item" style={{ width: '100%', float: 'none', paddingLeft: 0 }}>
                                    <label className="ui-label" style={{ float: 'none', width: 'auto', marginLeft: 0, marginRight: 10, padding: 0, display: 'inline-block', verticalAlign: 'top' }}><span style={{ color: 'red' }}>*</span>建号申请审批结论</label>
                                    <span className="ui-text">
                                        <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                            <Radio value='AGREE'>审批通过</Radio>
                                            <Radio value='DISAGREE'>审批不通过</Radio>
                                        </RadioGroup>
                                    </span>
                                </div>
                            </li>
                            {
                                approvalStatus == 'DISAGREE' &&
                                <li className="preview-item">
                                    <div className="item" style={{ width: '100%', float: 'none', paddingLeft: 0 }}>
                                        <label className="ui-label" style={{ float: 'none', width: 'auto', marginLeft: 0, marginRight: 10, padding: 0, display: 'inline-block', verticalAlign: 'top' }}><span style={{ color: 'red' }}>*</span>审批不通过原因</label>
                                        <span className="ui-text">
                                            <Input
                                                type="textarea"
                                                rows={3}
                                                placeholder="请输入审批不通过原因"
                                                style={{ width: 250 }}
                                                value={comments}
                                                onChange={e => this.handleInputChange(e, 'comments')}
                                            />
                                        </span>
                                    </div>
                                </li>
                            }
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

export default AssistantApproval;



// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/AssistantApproval.js